(function () {
  function getProductForm() {
    const mainProduct = document.querySelector('[id^="MainProduct-"]');
    if (mainProduct) {
      const form = mainProduct.querySelector('product-form form');
      if (form) return form;
    }

    const productForm = document.querySelector('product-form form');
    return productForm || null;
  }

  function getProductFormComponent() {
    const mainProduct = document.querySelector('[id^="MainProduct-"]');
    if (mainProduct) {
      return mainProduct.querySelector('product-form');
    }

    return document.querySelector('product-form');
  }

  function getQuantityInput() {
    const mainProduct = document.querySelector('[id^="MainProduct-"]');
    if (!mainProduct) return document.querySelector('input[name="quantity"]');

    return (
      mainProduct.querySelector('input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]')
    );
  }

  function readQuantity() {
    const qtyInput = getQuantityInput();
    if (!qtyInput) return 1;

    const qty = parseInt(qtyInput.value, 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getProductTitle() {
    const titleEl = document.querySelector('[id^="MainProduct-"] .product__title');
    return titleEl ? titleEl.textContent.trim() : '';
  }

  function collectFormLineItemProperties(form) {
    const properties = {};
    const formData = new FormData(form);

    formData.forEach(function (value, key) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') {
        properties[match[1]] = value;
      }
    });

    return properties;
  }

  function beginFormLoading(productFormComponent) {
    if (!productFormComponent) return;

    productFormComponent.handleErrorMessage();
    productFormComponent.submitButton.setAttribute('aria-disabled', 'true');
    productFormComponent.submitButton.classList.add('loading');
    productFormComponent.querySelector('.loading__spinner').classList.remove('hidden');
  }

  function endFormLoading(productFormComponent) {
    if (!productFormComponent) return;

    productFormComponent.submitButton.classList.remove('loading');
    productFormComponent.querySelector('.loading__spinner').classList.add('hidden');

    if (!productFormComponent.error) {
      productFormComponent.submitButton.removeAttribute('aria-disabled');
    }
  }

  function cartAddItems(items, shouldRenderDrawer) {
    const cartDrawer = document.querySelector('cart-drawer');
    const body = { items: items };

    if (shouldRenderDrawer && cartDrawer) {
      body.sections = cartDrawer
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',');
      body.sections_url = window.location.pathname;
      cartDrawer.setActiveElement(document.activeElement);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    // Avoid cached POST responses from intermediate caches.
    config.cache = 'no-store';
    config.body = JSON.stringify(body);

    return fetch(routes.cart_add_url, config).then(function (response) {
      return response.json();
    });
  }

  function fetchCart() {
    return fetch(`${window.Shopify?.routes?.root || '/'}cart.js?timestamp=${Date.now()}`, {
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (response) {
      if (!response.ok) throw new Error('Warenkorb konnte nicht geladen werden.');
      return response.json();
    });
  }

  function cartChangeQuantity(lineKey, quantity) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.cache = 'no-store';
    config.body = JSON.stringify({
      id: lineKey,
      quantity: quantity,
    });

    return fetch(routes.cart_change_url, config).then(function (response) {
      return response.json();
    });
  }

  function normalizeComparableProperties(properties) {
    const result = {};
    if (!properties) return result;

    Object.keys(properties).forEach(function (key) {
      if (key.charAt(0) === '_') return;
      const value = properties[key];
      if (value === null || value === undefined || value === '') return;
      result[key] = String(value);
    });

    return result;
  }

  function propertiesEqual(leftProperties, rightProperties) {
    const left = normalizeComparableProperties(leftProperties);
    const right = normalizeComparableProperties(rightProperties);
    const leftKeys = Object.keys(left).sort();
    const rightKeys = Object.keys(right).sort();

    if (leftKeys.length !== rightKeys.length) return false;

    return leftKeys.every(function (key, index) {
      return key === rightKeys[index] && left[key] === right[key];
    });
  }

  function findExistingParentLine(cart, variantId, properties) {
    if (!cart || !cart.items || !cart.items.length) return null;

    return (
      cart.items.find(function (item) {
        if (Number(item.variant_id) !== Number(variantId)) return false;
        if (item.parent_relationship && item.parent_relationship.parent_key) return false;
        return propertiesEqual(item.properties, properties);
      }) || null
    );
  }

  function assertCartAddOk(response, productFormComponent) {
    if (!response.status) return response;

    if (productFormComponent) {
      productFormComponent.handleErrorMessage(response.description);
      productFormComponent.error = true;
    }

    if (typeof publish !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'agrotropic-product-addons',
        errors: response.errors || response.description,
        message: response.message,
      });
    }

    throw new Error(response.description || 'Add-on konnte nicht zum Warenkorb hinzugefügt werden.');
  }

  function finishDrawerUpdate(response, productFormComponent, variantId) {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) {
      window.location = window.routes.cart_url;
      return;
    }

    if (productFormComponent) {
      productFormComponent.error = false;
    }

    if (typeof publish !== 'undefined') {
      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'agrotropic-product-addons',
        productVariantId: variantId,
        cartData: response,
      }).then(function () {
        CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
      });
    }

    CartPerformance.measure('add:paint-updated-sections', function () {
      cartDrawer.renderContents(response);
    });

    if (cartDrawer.classList.contains('is-empty')) {
      cartDrawer.classList.remove('is-empty');
    }
  }

  // Merge same product into one parent line; nest add-ons under it.
  // First add: parent_id in the same request. Later adds: bump qty + parent_line_key.
  function buildParentItem(form, quantity) {
    const parentVariantId = parseInt(form.querySelector('[name="id"]').value, 10);
    const bouquetProperties = collectFormLineItemProperties(form);
    const mainItem = {
      id: parentVariantId,
      quantity: quantity,
    };

    if (Object.keys(bouquetProperties).length > 0) {
      mainItem.properties = bouquetProperties;
    }

    const sellingPlanInput = form.querySelector('[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value) {
      mainItem.selling_plan = parseInt(sellingPlanInput.value, 10);
    }

    return {
      mainItem: mainItem,
      parentVariantId: parentVariantId,
      bouquetProperties: bouquetProperties,
    };
  }

  function buildNestedAddonItems(addonVariantIds, quantity, productTitle, parentRef) {
    return addonVariantIds.map(function (variantId) {
      const item = {
        id: parseInt(variantId, 10),
        quantity: quantity,
        properties: {
          Für: productTitle,
          _product_addon: 'true',
        },
      };

      if (parentRef.parent_line_key) {
        item.parent_line_key = parentRef.parent_line_key;
      } else {
        item.parent_id = parentRef.parent_id;
      }

      return item;
    });
  }

  function buildFirstAddItems(form, addonVariantIds, quantity, productTitle) {
    const parent = buildParentItem(form, quantity);
    return [parent.mainItem].concat(
      buildNestedAddonItems(addonVariantIds, quantity, productTitle, {
        parent_id: parent.parentVariantId,
      })
    );
  }

  function initAddonSlider(root) {
    const sliderRoot = root.querySelector('[data-agrotropic-addon-slider]');
    if (!sliderRoot || sliderRoot.dataset.addonSliderInit === 'true') return;

    const slider = sliderRoot.querySelector('[id^="Slider-"]');
    const prevButton = sliderRoot.querySelector('button[name="previous"]');
    const nextButton = sliderRoot.querySelector('button[name="next"]');
    const currentEl = sliderRoot.querySelector('.agrotropic-product-addons__slider-current');
    const totalEl = sliderRoot.querySelector('.agrotropic-product-addons__slider-total');

    if (!slider || !prevButton || !nextButton) return;

    const slidesPerPage = parseInt(sliderRoot.dataset.slidesPerPage, 10) || 2;
    let slides = [];
    let activePage = 1;
    let scrollLockUntil = 0;

    function refreshSlides() {
      slides = Array.from(slider.querySelectorAll('[id^="Slide-"]'));
    }

    function getPageCount() {
      return Math.max(1, Math.ceil(slides.length / slidesPerPage));
    }

    function getPageStartIndex(page) {
      return Math.min((page - 1) * slidesPerPage, Math.max(slides.length - 1, 0));
    }

    function getTargetScrollLeft(page) {
      const slide = slides[getPageStartIndex(page)];
      return slide ? slide.offsetLeft : 0;
    }

    function detectPageFromScroll() {
      if (!slides.length) return 1;

      const sliderRect = slider.getBoundingClientRect();
      let leftmostIndex = 0;
      let minDistance = Infinity;

      slides.forEach(function (slide, index) {
        const distance = Math.abs(slide.getBoundingClientRect().left - sliderRect.left);
        if (distance < minDistance) {
          minDistance = distance;
          leftmostIndex = index;
        }
      });

      return Math.min(Math.floor(leftmostIndex / slidesPerPage) + 1, getPageCount());
    }

    function updateCounter() {
      const pageCount = getPageCount();
      activePage = Math.min(Math.max(activePage, 1), pageCount);

      if (currentEl) currentEl.textContent = String(activePage);
      if (totalEl) totalEl.textContent = String(pageCount);

      prevButton.toggleAttribute('disabled', activePage <= 1);
      nextButton.toggleAttribute('disabled', activePage >= pageCount);
    }

    function scrollToPage(page, behavior) {
      refreshSlides();
      if (slides.length < 2) return;

      const pageCount = getPageCount();
      activePage = Math.min(Math.max(page, 1), pageCount);
      scrollLockUntil = Date.now() + 500;

      slider.scrollTo({
        left: getTargetScrollLeft(activePage),
        behavior: behavior || 'smooth',
      });

      updateCounter();
    }

    function onScroll() {
      if (Date.now() < scrollLockUntil) return;

      refreshSlides();
      activePage = detectPageFromScroll();
      updateCounter();
    }

    function setupSlider() {
      refreshSlides();
      if (slides.length < 2) return false;

      const lastSlide = slides[slides.length - 1];
      if (lastSlide.offsetLeft <= 0 && slides.length > 1) {
        return false;
      }

      sliderRoot.dataset.addonSliderInit = 'true';
      activePage = detectPageFromScroll();
      updateCounter();
      return true;
    }

    prevButton.addEventListener('click', function (event) {
      event.preventDefault();
      scrollToPage(activePage - 1);
    });

    nextButton.addEventListener('click', function (event) {
      event.preventDefault();
      scrollToPage(activePage + 1);
    });

    slider.addEventListener('scroll', function () {
      window.requestAnimationFrame(onScroll);
    }, { passive: true });

    if ('onscrollend' in window) {
      slider.addEventListener('scrollend', onScroll, { passive: true });
    }

    const resizeObserver = new ResizeObserver(function () {
      refreshSlides();
      onScroll();
    });
    resizeObserver.observe(slider);

    function trySetup(attempt) {
      if (setupSlider()) return;
      if (attempt >= 30) {
        sliderRoot.dataset.addonSliderInit = 'true';
        updateCounter();
        return;
      }
      window.requestAnimationFrame(function () {
        trySetup(attempt + 1);
      });
    }

    if (document.readyState === 'complete') {
      trySetup(0);
    } else {
      window.addEventListener(
        'load',
        function () {
          trySetup(0);
        },
        { once: true }
      );
    }
  }

  function initSection(root) {
    if (root.dataset.addonsInit === 'true') return;
    root.dataset.addonsInit = 'true';

    const selectionMode = root.dataset.selectionMode || 'single';
    const cards = Array.from(root.querySelectorAll('.agrotropic-product-addon-card'));
    let bypassIntercept = false;

    function getSelectedVariantIds() {
      return cards
        .filter(function (card) {
          return card.classList.contains('is-selected') && card.dataset.variantId;
        })
        .map(function (card) {
          return card.dataset.variantId;
        });
    }

    function selectCard(card) {
      if (selectionMode === 'single') {
        cards.forEach(function (item) {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
      }

      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');

      const listItem = card.closest('li');
      if (listItem) {
        listItem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });
      }
    }

    function deselectCard(card) {
      card.classList.remove('is-selected');
      card.setAttribute('aria-pressed', 'false');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        const isSelected = card.classList.contains('is-selected');

        if (isSelected) {
          deselectCard(card);
          return;
        }

        selectCard(card);
      });
    });

    function submitWithAddons(addonVariantIds) {
      const form = getProductForm();
      const productFormComponent = getProductFormComponent();

      if (!form || !productFormComponent) {
        return Promise.resolve();
      }

      const quantity = readQuantity();
      const productTitle = getProductTitle();
      const variantId = form.querySelector('[name="id"]').value;
      const parent = buildParentItem(form, quantity);

      beginFormLoading(productFormComponent);

      return fetchCart()
        .then(function (cart) {
          const existingParent = findExistingParentLine(
            cart,
            parent.parentVariantId,
            parent.bouquetProperties
          );

          if (existingParent) {
            return cartChangeQuantity(existingParent.key, existingParent.quantity + quantity).then(
              function (changeResponse) {
                if (changeResponse.status) {
                  throw new Error(
                    changeResponse.description || 'Menge konnte nicht aktualisiert werden.'
                  );
                }

                return cartAddItems(
                  buildNestedAddonItems(addonVariantIds, quantity, productTitle, {
                    parent_line_key: existingParent.key,
                  }),
                  true
                );
              }
            );
          }

          return cartAddItems(
            buildFirstAddItems(form, addonVariantIds, quantity, productTitle),
            true
          );
        })
        .then(function (response) {
          assertCartAddOk(response, productFormComponent);
          finishDrawerUpdate(response, productFormComponent, variantId);
          return response;
        })
        .catch(function (error) {
          console.error('[agrotropic-product-addons]', error);
          alert(error.message);
        })
        .finally(function () {
          endFormLoading(productFormComponent);
        });
    }

    function handleFormSubmit(event) {
      if (bypassIntercept) {
        bypassIntercept = false;
        return;
      }

      const form = getProductForm();
      const productFormComponent = getProductFormComponent();
      const submitButton = productFormComponent ? productFormComponent.submitButton : null;

      if (submitButton && (submitButton.getAttribute('aria-disabled') === 'true' || submitButton.disabled)) {
        return;
      }

      if (window.agrotropicProductLineNote && !window.agrotropicProductLineNote.validate(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      const addonVariantIds = getSelectedVariantIds();
      if (addonVariantIds.length === 0) {
        return;
      }

      const greetingModal = document.getElementById('flower-addon-modal');
      const greetingProceed = form && form.dataset.greetingCardProceed === 'true';
      if (greetingModal && !greetingProceed) {
        return;
      }

      if (greetingProceed && form) {
        delete form.dataset.greetingCardProceed;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      submitWithAddons(addonVariantIds);
    }

    function setupFormIntercept() {
      const form = getProductForm();
      if (!form || form.dataset.agrotropicAddonsIntercept === 'true') return;

      form.dataset.agrotropicAddonsIntercept = 'true';
      form.addEventListener('submit', handleFormSubmit, true);
    }

    function waitForProductForm() {
      let attempts = 0;
      const timer = setInterval(function () {
        attempts += 1;
        if (getProductForm() || attempts > 100) {
          clearInterval(timer);
          setupFormIntercept();
        }
      }, 100);
    }

    waitForProductForm();
    initAddonSlider(root);

    if (typeof subscribe !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setupFormIntercept();
      });
    }
  }

  function bootstrap() {
    document.querySelectorAll('[data-agrotropic-product-addons]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-agrotropic-product-addons]');
    if (root) initSection(root);
  });
})();
